import React, { type JSX } from 'react'
import Script from 'next/script'
import { logger } from '@/utils/logging'

export const isCaptchaReady = async (): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      grecaptcha.enterprise.ready(() => {
        resolve()
      })
    } catch (err) {
      logger().error('grecaptcha failed to load', err)
      reject()
    }
  })
}
export const generateRecaptchaToken = async (action: string) => {
  try {
    await isCaptchaReady()
    return await grecaptcha.enterprise.execute(process.env.NEXT_PUBLIC_RECAPTCHA_KEY as string, {
      action,
    })
  } catch (err) {
    logger().error('grecaptcha failed to retrieve token', err)
  }
}

export const Captcha = (): JSX.Element => {
  return (
    <Script src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_KEY}`} />
  )
}
